import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { TbWheat, TbPill } from 'react-icons/tb';
import moment from 'moment';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,openFeedFormulationMaterial,openFeedFormulationMedicine, onCopy, farmShedHash}) => {
    // Same active check as the desktop Active column
    const isActive = (moment(data.date) >= farmShedHash[data.farmID + "_" + data.shedID]) || (moment(data.date) >= farmShedHash["storage_" + data.feedStorageID]);

    const rows = [
        { label: 'Active', value: <FiberManualRecordIcon fontSize="small" style={{ color: isActive ? '#4caf50' : '#f44336' }} />, inHeader: true, hideLabel: true },
        { label: 'Farm / Storage', value: data.isStorage ? `${data.feedStorageName} (Storage)` : data.farmName },
        { label: 'Shed', value: data.shedName },
        { label: 'Materials / Medicines', value: (
            <>
                <IconButton onClick={openFeedFormulationMaterial} size="small" color="primary" aria-label="Materials"><TbWheat /></IconButton>
                <IconButton onClick={openFeedFormulationMedicine} size="small" color="secondary" aria-label="Medicines"><TbPill /></IconButton>
            </>
        ) },
    ];

    const menuItems = [
        { label: 'Delete', onClick: onDelete },
        { label: 'Copy', onClick: onCopy },
    ];

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
